import { Box, Button, Input, styled, TextField, Stack, Select, MenuItem, FormLabel, Typography, InputLabel, FormControl } from "@mui/material"
import PageContainer from "../../components/PageContainer"
import { PageHeader } from "../../components/Layout/PageHeader"
import { translate, Translate } from "react-i18nify"
import { useEffect, useState } from "react"
import { DeviceService } from "../../services/DataService"
import { DEVICE_TYPE } from "../Production/Production"
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { LoadingButton } from "@mui/lab"
import { CloudUpload } from "@mui/icons-material"
import AlertBox from "../../components/AlertBox"
import { useNavigate } from "react-router-dom"

export const UploadTraceProtocol = ({}) => {
    const navigate = useNavigate()

    const [selectedPType, setSelectedPType] = useState("");
    const [file, setFile] = useState(null);
    const [testCaseCount, setTestCaseCount] = useState(0)
    const [testEqCount, setTestEqCount] = useState(0)
    const [protocolScope, setProtocolScope] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false)
    const [selectError, setSelectError] = useState({ count: false, type: false, equipment: false })
    const [disableSubmit, setDisableSubmit] = useState(true)
    const [alertBox, setAlertBox] = useState({
        "visiblity": false,
        "statusCode": null,
        "text": null,
        "error": null
    })
    

    
    const hotRegex = new RegExp('\\bhot\\b','i')
    const proRegex = new RegExp('\\bpro\\b','i')

    const FileInput = styled('input')({
        display: 'none',
    });

    const onFileSelect = (e) => {
        try {
            var file = e.target.files
            if(file.length === 0)
                return 

            setFile(file[0])
        } catch (error) {
            console.error(error)
        }
    }

    const onTextChange = (e, countType) => {
        const newValue = e.target.value
        
        if(newValue <= 0 && countType === 0){
            setSelectError(prev => {
                return {
                    ...prev, 
                    count: true
                }
            })            
        }else if(newValue <= 0 && countType === 1){
            setSelectError(prev => {
                return {
                    ...prev, 
                    equipment: true
                }
            })
        }else{
            if(countType === 0){
                setSelectError(prev => {
                    return {
                        ...prev, 
                        count: false
                    }
                })
            }else{
                setSelectError(prev => {
                    return {
                        ...prev, 
                        equipment: false
                    }
                })
            }
        }
        if(countType === 0)
            setTestCaseCount(newValue)
        else
            setTestEqCount(newValue)
    }

    const disButton = () => {
        let disable = false
        if(file != null){
            if(selectError.count || selectError.type)
                disable = true
            return disable
        }else 
            return true

    }

    const dismissAlertBox = () => {
        setAlertBox({
            "visiblity": false,
            "statusCode": null,
            "text": null,
            "error": null
        })
    }

    const handleAlertBox = (visiblity, statusCode, text, error) => {
        setAlertBox({
            "visiblity": visiblity,
            "statusCode": statusCode,
            "text": text,
            "error": error
        })
    }

    const checkInputError = () => {
        let error  = false;
        if(protocolScope === ""){
            setSelectError(prev => {
                return {
                    ...prev,
                    type: true
                }
            })
            error = true
        }
        if(selectedPType === TRACE_PROTOCOL_TYPES.TEST.code){
            if(testCaseCount <= 0){
                setSelectError(prev => {
                    return {
                        ...prev, 
                        count: true
                    }
                })
                error = true
            }
        }
        return error
    }


    const UploadFile = (e) => {
        setSubmitLoading(true)
        if(checkInputError()){
            setSubmitLoading(false)
            return
        }

        let form = new FormData();
        if(selectedPType === TRACE_PROTOCOL_TYPES.TEST.code){
            form.append("testCaseCount", testCaseCount)
            form.append("testEquipmentCount", testEqCount)
        }

        form.append("file", file)
        form.append("scope", protocolScope)

        DeviceService.uploadTestDocument(form, selectedPType).then(res => {
            handleAlertBox(true, res.status, res.data, null)
            setTimeout(() => {
                navigate(`/O2maticAdministrator`);
            }, 4000)

        }).catch(e => {
            try{
                let errorData = e.response.data;
                let errorMsg =  "";
                if(errorData.errors != null)
                    Object.keys(errorData.errors).forEach(e => {
                        errorMsg += errorData.errors[e] + "\r\n"
                    });

                if(typeof(errorData) === "string")
                    errorMsg += errorData + "\r\n";
                
                if(errorData.detail != null)
                    errorMsg += errorData.detail + "\r\n";

                // handleAlertBox(true, e.response.status, e.response.data.detail == null ? e.response.data : e.response.data.detail, null)
                handleAlertBox(true, e.response.status, errorMsg, null)

            }catch(e){
                handleAlertBox(true, e.response.status, null, null)
            }
        }).finally(() => {
            setSubmitLoading(false)
        })
    }
    
    useEffect(() => {
        if(file != null){
            if(protocolScope === ""){
                if(hotRegex.test(file.name))
                    setProtocolScope(PROTOCOL_SCOPE.HOT)
                else if(proRegex.test(file.name))
                    setProtocolScope(PROTOCOL_SCOPE.PRO)
                else
                    setProtocolScope(PROTOCOL_SCOPE.UNIVERSAL)
            }
            if(selectedPType === TRACE_PROTOCOL_TYPES.TEST.code){
                if(testCaseCount <= 0){
                    setSelectError(prev => {
                        return {
                            ...prev, 
                            count: true
                        }
                    })
                }
            }
        }
    },[file])

    useEffect(() => {
        setDisableSubmit(disButton())
    },[file,selectError])

    return(
        <PageContainer>
            <PageHeader leftAlign>
                <Translate value="UploadTraceProtocolHeader" /> 
            </PageHeader>
            <Typography sx={{ mt: 1, mb: 1 }} variant="h6">
                <Translate value="UploadTraceProtocolExplainer"/>
            </Typography>
            <Box display={"flex"} flexDirection={"column"} sx={{mt:4, width: { xs: 100, md:500}}}>
                <Box sx={{ mb: 5 }}>
                    <FormControl>
                    <InputLabel id="SelectPTypeLabel">{translate("SelectProtocolType")}</InputLabel>
                    <Select
                            label="SelectPT"
                            labelId="SelectPTypeLabel"
                            onChange={(e) => {
                                setSelectedPType(e.target.value)
                            }}
                            value={selectedPType || ""}
                            sx={{ width: 290 }} 
                        >
                            {
                                Object.keys(TRACE_PROTOCOL_TYPES).map((v,k) => {
                                    return (
                                        <MenuItem key={k} value={TRACE_PROTOCOL_TYPES[v].code}>{translate(TRACE_PROTOCOL_TYPES[v].label)}</MenuItem>
                                    )
                                })
                            }
                    </Select>
                    </FormControl>
                </Box>
                {
                    selectedPType === "" ? 
                    <></>
                    :
                    <Box>
                        <Box flexGrow={1} id="UploadFileBox">
                            <Button
                                variant="outlined"
                                component="label"
                                fullWidth
                                startIcon={<InsertDriveFileIcon/>}
                                >
                                <FileInput accept=".pdf, .PDF" id="contained-button-file" multiple type="file" onChange={onFileSelect} />
                                {
                                    file != null ? 
                                        file.name
                                    : 
                                        <Translate value="SelectFile" />
                                    
                                }
                                
                            </Button>
                        </Box>

                            <Box 
                                display={"flex"} 
                                flexDirection={"row"}
                                sx={{mt:2}}
                            >
                                <Box flexGrow={1} sx={{ mr: 1 }} >
                                    <FormControl error={false} >
                                    <InputLabel id="DeviceTypelabel">{translate("SelectProtocolScope")}</InputLabel>
                                    <Select 
                                        label="SelectLabel"
                                        labelId="DeviceTypelabel"
                                        onChange={(e) => {
                                            setProtocolScope(e.target.value)
                                        }}
                                        value={protocolScope || ""}
                                        sx={{ width: 290 }} 
                                    >
                                        {
                                            Object.keys(PROTOCOL_SCOPE).map((v,k) => {
                                                return (
                                                    <MenuItem key={k} value={PROTOCOL_SCOPE[v]}>{PROTOCOL_SCOPE[v]}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                    </FormControl>
                                </Box>
                                <Box>
                                    {
                                        selectedPType === TRACE_PROTOCOL_TYPES.TEST.code ?
                                        <Box flexGrow={2} sx={{ height: 50, mb:5 }} >
                                            <TextField 
                                                label={translate("TestCaseCount")}
                                                onChange={(e) => onTextChange(e,0)}
                                                type="number" 
                                                error={selectError.count}
                                                helperText={selectError.count ? translate("TestCaseCountError") : ""}
                                            />
                                        </Box>
                                        : 
                                        <></>

                                    }
                                    {
                                        selectedPType === TRACE_PROTOCOL_TYPES.TEST.code ?
                                        <Box flexGrow={2} sx={{ height: 50 }} >
                                            <TextField 
                                                label={translate("TestEquipmentCount")}
                                                onChange={(e) => onTextChange(e,1)}
                                                type="number" 
                                                error={selectError.equipment}
                                                helperText={selectError.equipment ? translate("TestEquipmentCountError") : ""}
                                            />
                                        </Box>
                                        : 
                                        <></>

                                    }
                                </Box>
                            </Box>                        
                        <Box flexGrow={1} sx={{ mt: 3 }} >
                            {
                                alertBox.visiblity === true ? 
                                <AlertBox
                                visible={alertBox.visiblity}
                                text={alertBox.text}
                                error={alertBox.error}
                                statusCode={alertBox.statusCode}
                                onHide={dismissAlertBox}
                                duration={4000}
                                />
                            :
                                <LoadingButton
                                loading={submitLoading}
                                variant="contained"
                                component="label"
                                type="submit"
                                onClick={UploadFile}
                                startIcon={<CloudUpload/>}
                                disabled={disableSubmit}
                                >
                                <Typography> <Translate value="UploadFile" /> </Typography>
                                </LoadingButton>
                            }
                        </Box>
                    </Box>
                }
            </Box>
        </PageContainer>
    )
}

const TRACE_PROTOCOL_TYPES = {
    TEST: { label: "TestProtocol", code: "testprotocol" },
    SERVICE: { label: "ServiceProtocol", code: "serviceprotocol" }

}

export const PROTOCOL_SCOPE = {
    HOT: "HOT",
    PRO: "PRO",
    UNIVERSAL: "Universal"
}